module.exports = __webpack_public_path__ + "static/media/github-light.b7a386b9.svg";